import React from "react";
import { Link } from "react-router-dom";
import { appointmentRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { useMockCustomer } from "./useMockCustomer";
import { Card, EmptyState, StatusBadge, baht, formatDate, useAsync } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function Bookings() {
  const { orgId } = useApp();
  const { tx } = useI18n();
  const { customer } = useMockCustomer(orgId);
  const { data: appointments } = useAsync(
    () => (customer ? appointmentRepo.all(orgId, (row) => row.customerId === customer.id) : Promise.resolve([])),
    [orgId, customer],
    []
  );

  const sorted = [...(appointments || [])].sort((a, b) => new Date(b.startAt) - new Date(a.startAt));

  return (
    <>
      <Link to="/app/booking" className="btn-crm btn-primary-crm btn-block-crm u-mb-16">+ {tx("จองคิวใหม่", "New booking")}</Link>

      {sorted.length === 0 ? (
        <EmptyState icon={<Icon name="calendar" />} text={tx("ยังไม่มีการจอง", "No bookings yet")} />
      ) : (
        sorted.map((item) => (
          <Card key={item.id}>
            <div className="u-between">
              <div>
                <div className="u-strong">{item.serviceName}</div>
                <div className="u-fs-13 u-muted">{formatDate(item.startAt, true)}</div>
              </div>
              <StatusBadge status={item.status} />
            </div>
            <div className="u-between u-mt-8 u-fs-13">
              <span>{baht(item.price)}</span>
              {item.depositAmount > 0 ? <span className={item.depositPaid ? "u-success" : "u-danger"}>{tx("มัดจำ", "Deposit")} {baht(item.depositAmount, 0)} {item.depositPaid ? "✓" : `(${tx("ยังไม่ชำระ", "unpaid")})`}</span> : null}
            </div>
          </Card>
        ))
      )}
    </>
  );
}
